import { get, post, postNoBody } from './client';
import {
  ForgotPasswordRequestSchema,
  LoginRequestSchema,
  LoginResponseSchema,
  ResetPasswordRequestSchema,
  UserSchema,
} from './schemas';
import type { z } from 'zod';

export type LoginInput = z.infer<typeof LoginRequestSchema>;
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordRequestSchema>;
export type ResetPasswordInput = z.infer<typeof ResetPasswordRequestSchema>;

export const authApi = {
  me: () => get('/auth/me', UserSchema),

  login: (input: LoginInput) =>
    post('/auth/login', input, LoginResponseSchema),

  forgotPassword: (input: ForgotPasswordInput) =>
    postNoBody('/auth/forgot-password', input),

  resetPassword: (input: ResetPasswordInput) =>
    postNoBody('/auth/reset-password', input),

  logout: () => postNoBody('/auth/logout'),

  changePassword: (input: { current_password: string; new_password: string }) =>
    postNoBody('/auth/change-password', input),
};
